__webpack_require__.p = "https://cdn.office.huit.edu.vn/openedx-assets/authn/";